import { UserPlanVo, UserProfile } from "@/api";
import creditIcon from "@/assets/images/credit-icon.png";
import { formatNumberWithCommas } from "@/util/formatNumber";
import Image from "next/image";
import Link from "next/link";
import React from "react";

interface CreditPlanLinkProps {
  userLoading: boolean;
  user: UserProfile | null;
  userPlan: UserPlanVo | null;
  userCredits: number;
}

export const CreditPlanLink: React.FC<CreditPlanLinkProps> = ({
  userLoading,
  user,
  userPlan,
  userCredits,
}) => {
  if (userLoading) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 px-4 py-2 font-medium rounded-full border border-text-primary/[.07] bg-black/20 backdrop-blur-xl text-text-primary cursor-pointer transition-all hover:bg-primary/[.15] hover:backdrop-blur-none">
      {user ? (
        <>
          <span className="flex items-center gap-2">
            <Image src={creditIcon} alt="Credit" width={14} height={14} />
            <span>{formatNumberWithCommas(userCredits)}</span>
          </span>
          <div className="w-px h-[15px] bg-white/60 hidden sm:block"></div>

          <span className="hidden sm:block">{userPlan ? userPlan.memberShipName : user ? "" : "Free"}</span>
        </>
      ) : (
        <Link
          href="/pricing"
          className={"text-text-primary!"}
          data-disable-progress={true}
        >Pricing</Link>
      )}
    </div>
  );
};
